<script>
export default {
  name: 'BaseSelectMenu',
  inheritAttrs: false,
  props: {
    value: {
      type: null,
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: 'label',
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    color: {
      type: String,
      default: 'primary',
    },
    transitionName: {
      type: String,
      default: 'fade-up',
    },
    selectionClass: {
      type: String,
      default: 'text-md text-center neutrals-grey-700-text',
    },
    itemTextClass: {
      type: String,
      default: 'text-md',
    },
    selectedItemClass: {
      type: String,
      default: '',
    },
    selectedItemTextClass: {
      type: String,
      default: '',
    },
    unselectedItemTextClass: {
      type: String,
      default: 'neutrals-grey-500-text',
    },
    menuProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    resolvedMenuProps() {
      const { contentClass, ...menuProps } = this.menuProps

      return {
        bottom: true,
        offsetY: true,
        closeOnClick: true,
        ...menuProps,
        contentClass: ['scrollbar-thin', contentClass]
          .filter(Boolean)
          .join(' '),
      }
    },
  },
  methods: {
    isSelected(item) {
      return item[this.itemValue] === this.value
    },
  },
}
</script>

<template>
  <v-select
    solo
    flat
    dense
    hide-details
    :value="value"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :menu-props="resolvedMenuProps"
    class="base-select-menu"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot:selection="{ item }">
      <transition :name="transitionName" mode="out-in">
        <span
          :key="`base-select-menu-selection-${item[itemValue]}`"
          :class="selectionClass"
        >
          {{ item[itemText] }}
        </span>
      </transition>
    </template>

    <template v-slot:item="{ item, attrs, on }">
      <v-list-item
        v-bind="attrs"
        dense
        :color="isSelected(item) ? color : ''"
        :class="{ [selectedItemClass]: isSelected(item) }"
        v-on="on"
      >
        <v-list-item-content class="justify-center py-2xs">
          <v-list-item-title
            :class="[
              itemTextClass,
              isSelected(item)
                ? selectedItemTextClass
                : unselectedItemTextClass,
            ]"
          >
            {{ item[itemText] }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<style lang="scss" scoped>
@import '@/styles/_vue-transitions.scss';

.fade-up-enter,
.fade-up-leave-to {
  transform: translateY(-4px);
}

::v-deep .base-select-menu .v-select__selections {
  justify-content: center;
}
</style>
